import React from 'react';
import Slider from 'react-slick';
import MainHeadline from '../../../../components/typography/main-headline';
import { ISectionContentSliderFields } from '../../../../global';

const ContentSlider: React.FC<ISectionContentSliderFields> = ({
  slides,
  showArrows,
  showDots,
}) => {
  const sliderSettings = {
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: showArrows,
    dots: showDots,
    className: 'pd-collection__content-slider slick--circle-arrow max-width',
  };

  return (
    <Slider {...sliderSettings}>
      {slides &&
        slides.map((slide) => {
          if (!slide || !slide.fields || !slide.fields.backgroundImage) return;

          return (
            <div key={slide.sys.id}>
              <div
                className="container bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url(${slide.fields.backgroundImage.fields.file.url})`,
                  minHeight: '60vh',
                }}
              >
                <div className="py-4 leading-tight md:py-6 lg:px-4 lg:py-12">
                  <div className="text-lg font-black uppercase text-other-white md:text-xl lg:text-2xl">
                    {slide.fields.title}
                  </div>
                  <MainHeadline color="text-text-dark-bg-contrast-white">
                    <div className="uppercase">{slide.fields.subTitle}</div>
                  </MainHeadline>
                </div>
              </div>
            </div>
          );
        })}
    </Slider>
  );
};

export default ContentSlider;
